export default {
 proxyCookies: true,
 clientAwareness: false,
 cookieAttributes: {"maxAge": 604800, "secure": true},
 clients: {"default": {"httpEndpoint": "https://kptissueprod-cms-ncvlm.ondigitalocean.app/graphql", "authType": "Bearer", "authHeader": "Authorization", "tokenName": "apollo:default.token", "tokenStorage": "cookie", "defaultOptions": {"query": {"fetchPolicy": "no-cache"}}}}
}